import React from 'react';

function TrafficMarshalDetails() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-4xl font-bold mb-8 text-center">Traffic Marshal Services UK</h1>
      <div className="bg-yellow-900 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200">
        <h2 className="text-3xl font-semibold mb-4 text-white">Overview</h2>
        <p className="text-white mb-4">
          Our traffic marshal services in the UK are essential for managing and directing traffic on construction sites, ensuring the safety of workers and the public. Traffic marshals play a crucial role in maintaining a safe and efficient traffic flow.
        </p>
        <h2 className="text-2xl font-semibold mb-4 text-white">Services We Offer</h2>
        <ul className="list-disc list-inside text-white space-y-2">
          <li>Traffic Control and Management</li>
          <li>Pedestrian Safety</li>
          <li>Vehicle Access Control</li>
          <li>Safety Signage Setup</li>
          <li>Communication with Drivers and Site Staff</li>
          <li>Incident Management and Reporting</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Why Choose Us?</h2>
        <p className="text-white mb-4">
          Our team of experienced traffic marshals in the UK is dedicated to ensuring the highest level of safety and efficiency on your construction site. We use the latest techniques and adhere to all safety regulations to provide exceptional service.
        </p>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Contact Us</h2>
        <p className="text-white">
          For more information about our traffic marshal services in the UK, please contact us at <a href="tel:07460395006" className="text-blue-500 hover:underline">0746 039 5006</a> or email us at <a href="mailto:info@crowndefencesecurity.co.uk" className="text-blue-500 hover:underline">info@crowndefencesecurity.co.uk</a>.
        </p>
      </div>
    </div>
  );
}

export default TrafficMarshalDetails;
